import React, { SVGProps } from 'react'
import withIcon from './hoc/withIcon'

const Plus: React.FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.9998 2.8284C8.33117 2.8284 8.5998 3.09703 8.5998 3.4284V7.39983H12.5712C12.9026 7.39983 13.1712 7.66846 13.1712 7.99983C13.1712 8.3312 12.9026 8.59983 12.5712 8.59983H8.5998V12.5713C8.5998 12.9026 8.33117 13.1713 7.9998 13.1713C7.66843 13.1713 7.3998 12.9026 7.3998 12.5713V8.59983H3.42837C3.097 8.59983 2.82837 8.3312 2.82837 7.99983C2.82837 7.66846 3.097 7.39983 3.42837 7.39983H7.3998V3.4284C7.3998 3.09703 7.66843 2.8284 7.9998 2.8284Z"
      />
    </svg>
  )
}

Plus.displayName = 'Plus'

export default withIcon(Plus)
